import React from "react";
import { object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import { handleTimeFormat } from "../../helper/date-utils";

import "./first-published.m.css";

const FirstPublished = ({ story, publisherName }) => {
  const isRepublished = story["published-at"] !== story["first-published-at"];
  const firstPublishedTime = handleTimeFormat(story["first-published-at"]);

  return isRepublished ? (
    <div styleName="published-wrapper">
      <span styleName="title">Published:&nbsp;</span>
      <time dateTime={new Date(story["first-published-at"]).toISOString()} styleName="date">
        {firstPublishedTime}
      </time>
    </div>
  ) : null;
};

FirstPublished.propTypes = {
  story: object,
  publisherName: string,
};

const mapStateToProps = (state) => ({
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
});

export default connect(mapStateToProps, null)(FirstPublished);
